<template>
  <div id="layout-main" :class="{'hotMap':$route.meta.title=='信号热力图'}">
    <router-view></router-view>
    <!-- v-if="$route.matched[1].meta.title!='地图'" -->
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "@/components/myElement/Footer.vue"
export default {
  name: "Main",
  components: {
    Footer,
  },
};
</script>
<style lang="less">
#layout-main {
  width: 100%;
  height: calc(100% - 1.12rem - 0.175rem);
  padding-bottom: 0.175rem;
  &.hotMap {
    height: calc(100vh - 1.12rem - 0.175rem);
  }
}
// .anchorBL,.amap-logo {
//   display: none !important;
// }

// .amap-container {
//   background-color: transparent !important;
// }

// .map-center .hotMap {
//   visibility: hidden !important;
// }

// .map-center .hotMap.amap-container {
//   visibility:visible !important;
// }
</style>